import React, { useCallback, useEffect, useState } from 'react';
import { MdOutlineMoreVert } from 'react-icons/md';
import { usePopper } from 'react-popper';
import { IEvent } from 'types';
import { useNavigate } from 'react-router-dom';
import { EVENT_MENU_URL } from 'data/menu';
import { useEventStatus } from './useEventStatus';
import useEventDelete from './useEventDelete';

interface Props {
  event: IEvent;
  onPreview?: () => void;
}

function Action({ event, onPreview }: Props) {
  const navigate = useNavigate();
  const { handleEventStatus } = useEventStatus({ event });
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>(null);
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(
    null,
  );
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    placement: 'bottom-end',
  });

  const [isOpen, setIsOpen] = useState(false);

  const handleOff = useCallback(() => setIsOpen(false), []);
  const { handleConfirmDelete } = useEventDelete(event);

  useEffect(() => {
    window.document.addEventListener('click', handleOff);

    () => window.document.removeEventListener('click', handleOff);
  }, []);

  return (
    <>
      <div
        css={{ position: 'absolute', right: '12px' }}
        ref={setReferenceElement}
        onClick={(e) => {
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
      >
        <MdOutlineMoreVert size={32} />
      </div>
      {isOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          ref={setPopperElement}
          style={styles.popper}
          {...attributes.popper}
          css={{
            backgroundColor: 'white',
            padding: '12px 8px',
            borderRadius: '4px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
          }}
        >
          <ul
            css={{
              '> li': {
                padding: '8px 40px 8px 8px',
                cursor: 'pointer',
                fontSize: '12px',
                '&:hover': {
                  backgroundColor: '#f7f7f7',
                },
              },
            }}
          >
            {onPreview && <li onClick={onPreview}>앱 미리보기</li>}
            <li
              onClick={() =>
                navigate(`${EVENT_MENU_URL['행사']}/${event.id}/schedule`)
              }
            >
              봉사 일정 관리
            </li>
            {event.eventStatus !== 'CANCELLED' && (
              <>
                <li
                  onClick={() =>
                    navigate(`${EVENT_MENU_URL['행사']}/${event.id}/edit`)
                  }
                >
                  기본정보 수정
                </li>
                {event.eventStatus === 'REVIEW' && (
                  <li onClick={() => handleEventStatus('RECRUITING')}>
                    행사 승인
                  </li>
                )}
                {event.eventStatus === 'RECRUITING' && (
                  <li onClick={() => handleEventStatus('RECRUITMENT_CLOSED')}>
                    모집 완료
                  </li>
                )}
                {event.eventStatus === 'RECRUITMENT_CLOSED' && (
                  <li onClick={() => handleEventStatus('COMPLETED')}>
                    진행 완료
                  </li>
                )}
                {event.eventStatus !== 'COMPLETED' && (
                  <li onClick={() => handleEventStatus('CANCELLED')}>
                    행사 취소
                  </li>
                )}
                <li onClick={handleConfirmDelete}>행사 삭제</li>
              </>
            )}
          </ul>
        </div>
      )}
    </>
  );
}

export default Action;
